// @owners { team: patients }
import { isAfter, isBefore, isValid, parseISO } from 'date-fns';

export const isDowntimeActive = (startsAt: string, expiresAt: string | null | undefined, now: Date): boolean => {
  const startsAtDate = parseISO(startsAt);
  if (!isValid(startsAtDate) || !isAfter(now, startsAtDate)) return false;

  // A missing/null expiresAt means an indefinite outage: active for as long as startsAt has
  // passed, with no upper bound. A present-but-malformed expiresAt still fails open (false),
  // same as a malformed startsAt — it's not treated as indefinite.
  if (expiresAt === null || expiresAt === undefined) return true;

  const expiresAtDate = parseISO(expiresAt);
  if (!isValid(expiresAtDate)) return false;

  return isBefore(now, expiresAtDate);
};
